import { combineReducers } from 'redux';
import userReducer from '../slices/userSlice';
import surveysReducer from '../slices/surveysSlice';
import surveyEditorReducer from '../slices/surveyEditorSlice';

const rootReducer = combineReducers({
    user: userReducer,
    surveys: surveysReducer,
    survey: surveyEditorReducer
    // other reducers (e.g. surveys) to be added here
});

export default rootReducer;